module.exports = __webpack_public_path__ + "img/Workday-white-small.d058401e.png";